import React from 'react';
import styled from 'styled-components'
import { Container, Col, Row } from 'reactstrap';
import { useSpring, animated } from 'react-spring';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CookiePermissionPopup = (props) => {

    const closeCookies = useSpring({
        opacity: props.cookiesOpen ? 1:1,
        transform: (!props.cookiesOpen) ? 'translate3d(0,110%,0)' : 'translate3d(0,0%,0)',
      });

    return (
        <CookiePermissionsContainer style={closeCookies}>
        <FlexCol jc="center">
                <StyledP> 
                    Please note that on our website, we use cookies to enchance your experience and for analytics. By continuing to use our website, you agree to our use of cookies and similar technologies.
                </StyledP>
        </FlexCol>
        <StyledCol xs="auto" jc="flex-end" style onClick={() => {props.setCookiesOpen(false)}}>
            <StyledFAIcon style={{cursor: 'pointer'}} size="2x" icon={["fas", "angle-double-down"]}></StyledFAIcon>
        </StyledCol>
      </CookiePermissionsContainer>
    )
};

export default CookiePermissionPopup;

const CookiePermissionsContainer = styled(animated(Container))`
    display: flex;
    align-items: center;
    position: fixed;
    top: 92vh;
    height: 8vh;
    max-width: 100%;
    width: 100%;
    background-color: rgba(239, 237, 240);
    z-index: 10;
    border-color: #9780af #372844 #372844 #9780af;
    box-shadow: 0px -1px 10px #9780af;


`;

const FlexCol = styled(Col)`
    display: flex;
    justify-content: ${props => props.jc};
`;

const StyledCol = styled(Col)`
    display: flex;
    justify-content: ${props => props.jc};
    align-items: top;
`;


const StyledFAIcon = styled(FontAwesomeIcon)`
    color: #9780af;
    justify-content: center;
    margin-top: -10px;
`;
const StyledP = styled.p`
    display: flex;
    margin-top: 10px;
`;